import {useChartTheme} from './useChartTheme';

export const useHeatScale = (
  tones: readonly string[] | undefined,
  max: number,
) => {
  const {palette} = useChartTheme();
  const scale = tones ? [...tones].reverse() : palette.heatmap;
  const cellColor = (amount: number) => {
    if (amount <= 0 || max <= 0) return 'action.hover';
    const step = Math.ceil((amount / max) * scale.length) - 1;
    return scale[Math.min(scale.length - 1, Math.max(0, step))];
  };
  return {scale, cellColor};
};
